import { LicenseInfo } from '@mui/x-license-pro';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Config } from './shared/config/config';
import './styles/main.scss';

LicenseInfo.setLicenseKey(Config.App.MUILicenseKey);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
